module.exports = {
  title: '车型配件设置',
  route: {
    path: '/business-configure',
    children: {
      path: 'cartype-parts-setup',
    },
  },
};
